export default "assets/images/background-magazine-0a9a2560.jpg";